import { Switch, Typography } from "@stardust-ds/react"
import { useState, useRef, useEffect } from "react"
import styles from "./index.module.scss"

export default function SwitchComponent(props) {
  const {
    cDisabledText,
    cAbleText,
    bSingleOption,
    onChange,
    value,
    width,
    bg,
    border,
    center = true,
    disabled,
    cSizeFont,
    bRulesWestgard = false,
    ...oRest
  } = props
  const [isChecked, setIsChecked] = useState(Boolean(value))

  const elSwitchContainer = useRef(null)
  const switchRef = useRef()

  useEffect(() => {
    // set button type as button
    if (!elSwitchContainer?.current?.children?.length) return
    ;[...elSwitchContainer.current.children].map((el) => {
      if (el?.type === "submit") el.type = "button"
    })
  }, [])

  useEffect(() => {
    if (value === undefined) return
    
    setIsChecked(Boolean(value))
  }, [value])

  useEffect(() => {
    onChange?.(isChecked)
  }, [isChecked])

  const cContainerClasses = `${styles.switchContainer} ${
    bSingleOption ? styles.switchContainerSingle : ""
  } ${disabled ? styles.disabled : ""}`

  const handleKeyDown = (event) => {
    if (event.key === " ") {
      event.preventDefault()
    }
  }

  return (
    <div
      ref={elSwitchContainer}
      className={cContainerClasses}
      style={{
        width: width ? width : "202px",
        background: bg ? bg : "#fff",
        border: border ? border : "1px solid #6CB6E3",
        display: center && "flex",
        justifyContent: center && "center",
        alignItems: center && "center",
      }}
      onKeyDown={handleKeyDown}
    >
      {!bSingleOption ? (
        <Typography
          type={"p3"}
          fontWeight={!isChecked ? "bold" : "normal"}
          color={!isChecked ? "#415364" : "#ACB4BA"}
        >
          {cDisabledText}
        </Typography>
      ) : (
        <p
          className={styles.singleOptionText}
          style={{ fontSize: cSizeFont ? cSizeFont : "normal" }}
        >
          {cDisabledText}
        </p>
      )}
      <Switch
        ref={switchRef}
        checked={isChecked}
        onChange={(e) => setIsChecked(e)}
        className={!isChecked ? styles.switchComponentDisabled : styles.switchComponent}
        disabled={disabled}
        dataDisable={!isChecked ? "disabled" : "abled"}
        {...oRest}
      />
      {!bSingleOption && (
        <Typography
          type={bRulesWestgard ? "p2" : "p3"}
          fontWeight={isChecked ? "bold" : "normal"}
          color={!isChecked ? "#ACB4BA" : "#1ECB4F"}
        >
          {cAbleText}
        </Typography>
      )}
    </div>
  )
}
